import { Component, OnDestroy } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { UIRouterGlobals } from "@uirouter/angular";
import { finalize } from "rxjs/operators";
import { SendDataService } from "../models/send-data.service";
import { EventService } from "../event-service/event.service";

@Component({
  selector: "ab-send-data-modal",
  templateUrl: "./send-data-modal.component.html",
})
export class SendDataModalComponent implements OnDestroy {
  public sendingData: boolean;

  constructor(
    public activeModal: NgbActiveModal,
    private sendDataService: SendDataService,
    private $uiRouterGlobals: UIRouterGlobals,
    private eventService: EventService,
  ) {}

  public sendData() {
    this.sendingData = true;
    this.sendDataService
      .post({ projectId: this.$uiRouterGlobals.params.projectId })
      .pipe(
        finalize(() => {
          window.setTimeout(() => {
            window.location.reload();
          }, 5000);
        }),
      )
      .subscribe();
  }

  public dismissModal() {
    this.eventService.publish("show-send-data-btn", !this.sendingData);
  }

  public ngOnDestroy() {
    this.dismissModal();
  }
}
